import type { ZoneLayout } from '../../zones/types';
import { buildEmberwild } from './emberwild';
import { buildFrosthollow } from './frosthollow';
import { buildHavenreach } from './havenreach';
import { buildSunscar } from './sunscar';

/**
 * Overworld (shared, non-instanced) zones by id. Builders are deterministic:
 * every call returns an identical layout, so peers can build them locally.
 */
export const OVERWORLD_ZONES: Record<string, () => ZoneLayout> = {
  emberwild: buildEmberwild,
  havenreach: buildHavenreach,
  sunscar: buildSunscar,
  frosthollow: buildFrosthollow,
};
